<template>
        <section class="landing landingbb purchase-sale purchase-sale-info">
        <div class="container">
                <div class="landing-content subpage-heading-center">
                    <span class="heading-title">{{ $t('SellMotoInt.header') }} </span>
                    <hr>
                    <span class="paragraph">{{ $t('SellMotoInt.description') }}</span>
                    <span class="paragraph">{{ $t('SellMotoInt.inserat') }}</span>

                    <img src="https://auto-moto-sales.web.app/images/7.png">
                    <img src="https://auto-moto-sales.web.app/images/5.png">
                    <img src="https://auto-moto-sales.web.app/images/6.png">
                    <img src="https://auto-moto-sales.web.app/images/4.png">

                    <span class="paragraph">{{ $t('SellMotoInt.dienstleistung') }}</span>
                    <span class="paragraph">{{ $t('SellMotoInt.internet') }}</span>
                    <router-link :to="localizedPath('motoSale')" class="a-link-routess"><i class="fa fa-sign-in" aria-hidden="true"></i> {{ $t('SellAutoInt.furtherpage') }}</router-link>
                </div>
            </div>
          </section>
  </template>
  
  <script>
  
  export default {
    name: 'SellMotoIntPage',
    computed: {
  
      localizedPath() {
        return (routeKey) => {
          return this.$localizedPath(routeKey);
        };
      }
      // ✅ Computed property to always get the current route name
  
    },
  };
  </script>
  
  <style scoped></style>
  